const breadcrumbs = {
  accessLevels: "Niveaux d'accès",
  controllers: 'Contrôleurs',
  credentials: 'Identifiants',
  dealerInfo: "Informations de l'installateur",
  dealerView: 'Vue installateur',
  doors: 'Portes',
  employees: 'Employés',
  events: 'Événements',
  firmwareManager: 'Gestionnaire de micrologiciel',
  floorPlans: "Plans d'étage",
  globalSettings: 'Paramètres globaux',
  hardware: 'Hardware',
  holidays: 'Jours fériés',
  inputs: 'Entrées',
  interlocks: 'Sas de sécurité',
  lockdown: 'Confinement',
  outputs: 'Sorties',
  schedules: 'Horaires',
  settings: 'Paramètres',
  sites: 'Sites',
  users: 'Utilisateurs',

  activate: 'Activer',
  create: 'Créer',
  edit: 'Modifier',
  manage: 'Gérer',
};

export default breadcrumbs;
